import { useEffect, useState } from "react";
import { getCaseList } from "../api/cases";
import { useSelector } from "react-redux";
import useErrorHandler from "./useErrorHandler";

const caseListCacheMap = new Map();
let selectedCaseId = "";
let selectedCaseName = "";

export default function useCaseList() {
  const [caseList, setCaseList] = useState([]);
  const [error, setError] = useState(null);
  const { data: user } = useSelector((state) => state.user);
  const token = user.token;
  const errorHandler = useErrorHandler();

  function setSelectedCaseId(id) {
    if (!id) {
      selectedCaseId = "";
    } else {
      selectedCaseId = id;
      if (caseList.length) {
        selectedCaseName = caseList.find((c) => c.id == parseInt(id))?.title;
      }
    }
  }

  useEffect(() => {
    if (caseListCacheMap.has(token)) {
      setCaseList(caseListCacheMap.get(token));
    } else if (token) {
      getCaseList(token)
        .then(({ data }) => {
          setCaseList(data.data);
          caseListCacheMap.set(token, data.data);
          setError(null);
        })
        .catch((error) => {
          errorHandler(error);
          setError(error);
        });
    }
  }, [token]);

  return {
    caseList,
    error,
    selectedCaseId,
    setSelectedCaseId,
    selectedCaseName,
  };
}
